<template>
    <div>
        <vs-tabs :v-model="selectedTab"  alignment="fixed" v-on:click-tag="faza()">
            <vs-tab  :label="$t('Customer.Tabs.Customer')" >
                <ViewSubIndustry :selected="selected">
                </ViewSubIndustry>
            <vs-button @click="close()" type="border" color="primary" class="border-0 border-bottom mr-4"> {{$t('Components.Queue.AddCustomerPrompt.CancelButton')}} </vs-button>

            </vs-tab>

            <vs-tab  :label="$t('Customer.Tabs.Modify')" >
                <UpdateSubIndustry :selected="selected"
                @hide="hide">
                </UpdateSubIndustry>
                            <!-- <vs-button @click="close()" type="border" color="primary" class="border-0 border-bottom mr-4"> {{$t('Components.Queue.AddCustomerPrompt.CancelButton')}} </vs-button> -->
            </vs-tab>


            
        </vs-tabs>
    </div>
</template>

<script>
import ViewSubIndustry from "../industry/ViewSubIndustry";
import UpdateSubIndustry from "../industry/UpdateSubIndustry";
export default {
    name: "AddCustomerCustomizer",
    data: () => ({
        service_prop: {},
        selected:{},
        archive: [],
        selectedTab: "",
    }),
    props:{
        selectedSubindustry: Object
    },
    components:{
        ViewSubIndustry,
        UpdateSubIndustry
    },
    methods:{
        hide(){
                  this.$emit('hide', 'hide');
        }
    },
    mounted(){
      this.selected = this.selectedSubindustry;
      this.selected.translations = JSON.parse(this.selected.translations)

    }
}
</script>